import { motion } from "framer-motion";
import { Crosshair, Scissors, UserCheck, Award } from "lucide-react";

const icons = [Crosshair, Scissors, UserCheck, Award];

export default function WhyChoose({ t }) {
  const features = t.whyChoose.features;

  return (
    <section
      id="why-choose"
      data-testid="why-choose-section"
      className="py-20 md:py-32 bg-[#0F0F0F]"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
          className="text-center mb-16"
        >
          <p className="text-xs tracking-[0.3em] sm:tracking-[0.38em] uppercase text-[#D4AF37] font-body mb-4">
            {t.whyChoose.sectionTitle}
          </p>
          <h2
            className="text-4xl md:text-5xl font-bold text-white font-heading"
            data-testid="why-choose-title"
          >
            {t.whyChoose.headline}
          </h2>
        </motion.div>

        <div
          className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6"
          data-testid="why-choose-cards"
        >
          {features.map((feature, i) => {
            const Icon = icons[i];
            return (
              <motion.div
                key={i}
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.7, delay: i * 0.12, ease: [0.22, 1, 0.36, 1] }}
                className="bg-[#1A1A1A] border border-white/5 p-6 sm:p-8 hover:border-[#D4AF37]/25 transition-colors duration-500 group"
                data-testid={`why-choose-card-${i}`}
              >
                <div className="mb-6 w-12 h-12 border border-[#D4AF37]/25 flex items-center justify-center group-hover:border-[#D4AF37]/60 transition-colors duration-300">
                  <Icon size={20} className="text-[#D4AF37]" />
                </div>
                <h3 className="text-lg font-heading text-white mb-2 group-hover:text-[#D4AF37] transition-colors duration-300 leading-snug">
                  {feature.title}
                </h3>
                <p className="text-white/65 text-sm font-body leading-relaxed">{feature.description}</p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
